export default {
  primary: "#4BCD3E",
  secondary: "#ffffff",
};
